<template>
<div class="row row-cols-2 align-items-center m-0 p-0 my-1">
	<div class="col col-md-2 p-0 px-2">
		<button
			class="btn btn-outline-secondary btn-sm m-1"
			@click="showGotifyManual"
		>
			push&nbsp;сповіщення
		</button>

		<pop-up-modal
			v-model:show="isGotifyManual"
			title="Налаштування сповіщень"
			size="modal-lg"
		>
			<template v-slot:body>
				<gotify-manual/>
			</template>
		</pop-up-modal>
	</div>

	<div class="col col-md-10 p-0 px-2 align-self-center">
		<input
			v-model.trim="search"
			type="search"
			class="form-control form-control-sm ms-auto"
			style="max-width: 15rem;"
			placeholder="Фільтрувати по назві"
			list="list-nodes"
			v-on:keydown.esc.stop="search=''"
		/>
	</div>
</div>

<easy-data-table
	class="data-table m-0 mx-1 p-0"
	table-class-name="customize-table"
	:key="rowsPerPage"
	:headers="headers"
	:items="filteredItems"
	:loading="isTableLoading"
	theme-color="rgb(198, 199, 200)"
	sort-by="name"
	sort-type="asc"
	:filter-options="filterOptions"
	:rows-items="[10,20,40,100]"
	:rows-per-page="rowsPerPage"
	rows-per-page-message="записів на сторінці"
	empty-message="немає записів"
	rows-of-page-separator-message=" з "
	:table-min-height="380"
	:table-height="easyDataTableHeight()"
	:prevent-context-menu-row="false"
	:body-item-class-name="tableItemClassName"
	alternating
	buttons-pagination
>
	<!-- Filter to organization column -->
	<template #[orgNameHeaderSlotName]="header">
		<!-- Don't create if criterias is empty because form will empty -->
		<table-filter-checkboxes
			v-if="organizationCriterias.length > 0"
			:criterias="organizationCriterias"
			:default-checked="sessionStore.getFilter($route.name, 'organization')"
			@checked-criterias="(criterias) => { saveFiters('organization', criterias) }"
		/>
		{{ header.text }}
	</template> 

	<template #expand="item">
		<div class="row p-0 m-0 g-0 bg-light">
			<Form
				@submit="onSubmit"
				@invalid-submit="console.log"
				:initial-values="item.form"
				:validation-schema="schema"
				v-slot="{/*errors,*/ meta}"
			>
			<fieldset class="container m-1">
				<div v-for="(column, index) in item.layout.columns" :key="item.id+index"
					class="row align-items-center my-1"
				>
					<div v-for="key in column" :key="item.id+index+key"
						class="col-xl-3 col-sm-6"
					>
						<div class="d-flex align-items-center">
						<Field
							:name="key"
							type="checkbox"
							id="allert-on-connection"
							class="form-check-input col-auto"
							:value="true"
							:uncheckedValue="false"
						/>
						<label for="allert-on-connection" class="form-check-label mx-2 my-0 col-auto">
							{{ notifacationText[key] ? notifacationText[key] : '-' }}
						</label>
						</div>
					</div>
				</div>

				<!-- <br>{{ errors }} -->
				<!-- <br>{{ meta }} -->

				<div class="row form-row mt-1 mb-3">
					<div class="form-group col-auto ms-auto me-2">
						&nbsp;
					</div>
					<div class="form-group col-auto me-0">
						<button
							type="submit"
							class="btn btn-primary btn-sm"
							:disabled="!meta.valid || !meta.dirty"
						>
							Зберегти
						</button>
					</div>
				</div>
			</fieldset>
			</Form>
		</div>
	</template>
</easy-data-table>
</template>


<script>
import { Form, Field } from 'vee-validate'
import TableFilterCheckboxes from '@/components/TableFilterCheckboxes.vue'
import GotifyManual from './GotifyManual.vue'
import PopUpModal from '../PopUpModal.vue'
import { useAccontStore } from '@/stores/AccountStore'
import { useSessionStore } from '@/stores/SessionStore'
import { ObjectPrototype } from '@/models/objectPrototype.js'
import {
	easyDataTableHeight,
	easyDataTableRowsPerPage,
} from '@/helpers.js'


export default {
	inject: ['headerHeight'],

	components: {
		Form,
		Field,
		TableFilterCheckboxes,
		GotifyManual,
		PopUpModal,
	},

	props: {
		//
		isTableLoading: {
			type: Boolean,
			required: true,
			default: true
		},

		headers: {
			type: Array,
			required: false,
			default: () => [
				{ text: 'Назва', value: 'name', sortable: true },
				{ text: 'Кількість підписок', value: 'subscriptions_count' },
			]
		},

		items: {
			type: Array,
			required: false,
			default: () => []
		},

		// Object { notification_key_from_items: text_for_user_interface }
		notifacationText: {
			type: Object,
			required: false,
			default: () => new Object()
		},

		onSubmit: {
			type: Function, // Function(formValues:Object)
			required: false,
			default: (v) => { console.log('Submit values ', v) }
		}
	},

	setup() {
		const accountStore = useAccontStore()
		const sessionStore = useSessionStore()

		return {
			accountStore,
			sessionStore,
			easyDataTableHeight,
			easyDataTableRowsPerPage,
		}
	},

	data() {
		return {
			// Table
			rowsPerPage: 20,
			// Filters
			filters: {
				organization: [],
			},

			//
			isGotifyManual: false,
			// For search input
			search: '',	// search phrase
		}
	},

	created() {},

	mounted() {
		this.rowsPerPage = easyDataTableRowsPerPage()
	},

	methods: {
		showGotifyManual() {
			this.isGotifyManual = true
		},

		tableItemClassName(column/*, index*/) {
			switch (column) {
				case'expand':
					return 'expand-mark'
				case 'subscriptions_count':
					return 'subscriptions-count'
				default:
					return ''
			}
		},

		saveFiters(filterName, criterias) {
			this.filters[filterName] = criterias;
			const filters = this.sessionStore.getFilter(this.$route.name, filterName);
			filters.splice(0, filters.length);
			filters.push(...criterias);
		},
	},

	computed: {
		showOrganizationColumn() {
			return this.headers.find((header) => header.value == ObjectPrototype.passportKeys.orgName) !== undefined
		},

		filteredItems() {
			const search = this.search.trim()
			// If search phrase is empty
			if (search === '') {
				return this.items
			// If search phrase is one word
			} else if (search.indexOf(' ') == -1) {
				// Filter items where any word starts with search phrase
				return this.items.filter((el) => {
					// Split string to words
					const words = el.name.toLowerCase().split(/\s+/)
					// Check awery word
					return words.some((word) => 
						word.startsWith(search.toLowerCase())
					)
				})
			} else {
				return this.items.filter((el) => el.name.toLowerCase().includes(search.toLowerCase()))
			}
		},

		organizationCriterias() {
			let names = []

			this.items.forEach((item) => {
				const name = item[ObjectPrototype.passportKeys.orgName]
				if (!names.includes(name)) {
					names.push(name)
				}
			})

			return names
		},

		filterOptions() {
			const filterOptionsArray = new Array()
			filterOptionsArray.push({
				field: ObjectPrototype.passportKeys.orgName,
				comparison: 'in',
				criteria: this.filters.organization,
			})

			return this.showOrganizationColumn ? filterOptionsArray : []
		},

		orgNameHeaderSlotName() { return "header-" + ObjectPrototype.passportKeys.orgName },
	},

	beforeUnmount() {},

	unmounted() {},
}
</script>




<style src="@/assets/table.css" scoped></style>
<style>
.expand-mark {
	min-width: 1rem;
	width: 2rem;
}

.subscriptions-count {
	min-width: 1rem;
	width: 10rem;
	max-width: 15rem;
}
</style>